import { defHttp } from '/@/utils/http'

export function accountCsrfTokenApi() {
  return defHttp.get({ url: '/api/account/csrf-token' }, { isReturnNativeResponse: true })
}

export function accountInfoApi() {
  return defHttp.get({ url: '/api/account/info' })
}

export function accountLoginApi(params: Recordable) {
  return defHttp.post({ url: '/api/account/login', params })
}

export function accountLogoutApi() {
  return defHttp.post({ url: '/api/account/logout' })
}

export function accountPasswordResetRequestApi(email: string) {
  return defHttp.post({ url: '/api/account/password-reset-request', params: { email } })
}

export function accountPasswordResetApi(params: Recordable) {
  return defHttp.post({ url: '/api/account/password-reset', params })
}

export function accountPasswordChangeApi(params: Recordable) {
  return defHttp.post({ url: '/api/account/password-change', params })
}

export function accountSendOTPTokenRequestApi(email: string) {
  return defHttp.post({ url: '/api/account/send-otp', params: { email } })
}

export function accountLoginWithOTPApi(params: Recordable) {
  return defHttp.post({ url: '/api/account/login-otp', params })
}

export function accountLoginWithMFAApi(otpCode: string) {
  return defHttp.post({ url: '/api/account/login-mfa', params: { otp_code: otpCode } })
}

export function unauthorizedAccountEnableMFAApi(params: Recordable) {
  return defHttp.post({ url: '/api/account/enable-mfa', params })
}

export function accountNotificationsReadApi(id: number | string) {
  return defHttp.post({ url: `/api/account/notifications/${id}/read` })
}

export function accountNotificationsListApi(params?: Recordable) {
  return defHttp.get({ url: '/api/account/notifications', params })
}

export function usersReleaseApi() {
  return defHttp.post({ url: '/api/users/release' })
}
